import React from 'react';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Slide from 'react-reveal/Slide';

import {SectionTitle} from 'component/reuse/title';
import {ModalFeedback} from 'component/reuse/modal';


function CategoryCard(props) {
  const category = props.category;
  return (
    <div className=" my-3">
      <div className="card-body text-black-4">
        <h4 className="family-h4 card-text my-4">{category.name}</h4>
        <div className="" style={{display: 'grid', justifyItems: 'center', alignItems: 'center'}}>
          <div className="rounded img img-fluid">
            <img data-src={category.image_url} className="lazyload category " alt={category.description} />  
          </div>
        </div>
        <p className="family-p card-text my-4 text-size-1">{category.description}</p>
      </div>
    </div>
  )
}

export default class Categories extends React.Component {
  render (){
    const categories = [
      {
        name: "Sales",
        image_url: '/static/images/categories/sales.svg',
        description: 'Close deals faster with a self serve portal with all your demo living live on your pages!',
      },
      {
        name: "Support",
        image_url: '/static/images/categories/support.svg',
        description: 'Get your customer\'s most common queries answered faster and without incurring operations cost',
      },
      {
        name: "Onboarding",
        image_url: '/static/images/categories/team.svg',
        description: 'Use onboarding shows to quickly train your staff on internal tools',
      },
      {
        name: "Engineering",
        image_url: '/static/images/categories/dev.svg',
        description: 'Build quick shows for product and engineering teams to be in sync on site operations and issues',
      },
    ]
    return (
      <section id="categories" className="content-section flex-center">
        <div className="container-fluid">
        <div className="" style={{display: 'grid', justifyItems: 'center', alignItems: 'center'}}>
          <SectionTitle first="" second="Use cases" background="quaternary"/>

          <div className='row text-center mt-4 mb-1'>
            {categories.map(function(category, idx){
              return(
                <div className='col-lg-3 col-md-3 col-sm-12 ' key={"i_" + idx}>
                    <Slide><CategoryCard category={category} /></Slide>
                </div>
              )
            })}
          </div>

          <div className="fa-pull-right mb-3">
            <ModalFeedback modalLinkText={"Other use cases in mind?"} modalID={"use_case_feedback"} modalTitle={"Use Cases"} />
          </div>

        </div>
        </div>
      </section>
    )
  }
}